// import Vue from "vue";
import { createI18n } from "vue-i18n";
function loadLocaleMessages() {
    const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale ?? ""] = locales(key);
        }
    });
    // type cast needed to solve this issue https://github.com/intlify/vue-i18n/issues/1119
    return messages;
}
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    // check if we have saved gui language
    locale: localStorage.getItem("lang") && localStorage.getItem("lang") != "null"
        ? (localStorage.getItem("lang") ?? undefined)
        : "cz",
    fallbackLocale: "en",
    silentTranslationWarn: true,
    messages: loadLocaleMessages()
});
export default i18n;
